import { DefaultWOTable } from "./DefaultWOTable";

export default DefaultWOTable;
